
import React, { useState, useEffect } from 'react';
import MaxLoanList from './MaxLoanList';
import losData from '../hybriddata/loanstatusdata.json'
import { CusFormLabel, SingleFormLabel, SingleFormLabelBold } from '../validation/Form-Components';
import JTCLoanList from './JTCLoanList';

const AAPLeaseholdProperty = (props) => {

    const {response,propertyData} = props;

    const [leaseholdApprovedList, setLeaseholdApprovedList] = useState([]);
    const [maxLoanNoPropList,setMaxLoanNoPropList] = useState([]);

    const [isJTCNonJTCApproved, setIsJTCNonJTCApproved] = useState(true);

    const loanTypeJTC = 'For JTC Property';
    const loanTypeNonJTC = 'For Non-JTC Property';

    useEffect(() => {

        console.log('@LeaseholdProperty useEffect');

        let tempArray = [];
        if(response.maxCIPAIPLoanAmtJTCLeasehold && response.maxCIPAIPLoanTenureJTCLeasehold &&
            response.maxCIPAIPLoanAmtNonJTCLeasehold && response.maxCIPAIPLoanTenureNonJTCLeasehold
        ) {
            const jtcObj = formatDataObj(loanTypeJTC,response.maxCIPAIPLoanTenureJTCLeasehold,response.maxCIPAIPLoanAmtJTCLeasehold);  
            tempArray.push(jtcObj);
            const nonJtcObj = formatDataObj(loanTypeNonJTC,response.maxCIPAIPLoanTenureNonJTCLeasehold,response.maxCIPAIPLoanAmtNonJTCLeasehold);
            tempArray.push(nonJtcObj);
            setIsJTCNonJTCApproved(true);
        }
        else if(response.maxCIPAIPLoanAmtJTCLeasehold && response.maxCIPAIPLoanTenureJTCLeasehold) {
            const jtcObj = formatDataObj(loanTypeJTC,response.maxCIPAIPLoanTenureJTCLeasehold,response.maxCIPAIPLoanAmtJTCLeasehold);  
            tempArray.push(jtcObj);
            setIsJTCNonJTCApproved(true);
        }
        else if(response.maxCIPAIPLoanAmtNonJTCLeasehold && response.maxCIPAIPLoanTenureNonJTCLeasehold) {
            const nonJtcObj = formatDataObj(loanTypeNonJTC,response.maxCIPAIPLoanTenureNonJTCLeasehold,response.maxCIPAIPLoanAmtNonJTCLeasehold);
            tempArray.push(nonJtcObj);
            setIsJTCNonJTCApproved(true);
        }
        else {
            setIsJTCNonJTCApproved(false);
            if(response.maxCIPAIPLoanAmtLeasehold && response.maxCIPAIPLoanTenureLeasehold){
     
                const formatObj = {
                    loanTenure: response.maxCIPAIPLoanTenureLeasehold,
                    loanAmount: response.maxCIPAIPLoanAmtLeasehold
                }
                tempArray.push(formatObj);
            } 
        }
     
        setLeaseholdApprovedList(tempArray);
        setMaxLoanNoPropList(response.maxLoanDetailsNoProp);

    }, []);

    const formatDataObj = (status,tenure, amount) => {
        const fObj = {
            loanType: status,
            loanTenure: tenure,
            loanAmount: amount
        }

        return fObj;
    }
   
    return(
        <div>
            <div className='pad-top10'>
                <SingleFormLabelBold labelId={'lblAIPtxt1'} labelName={losData.leasehold.txt1} />
                <div className="row around-xs inputPair elementVisible">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <span>{losData.leasehold.txt1_desc}</span>
                        <span className='txt-grey-fs16'>{propertyData.PropertyAddress}</span>
                    </div>
                </div>
            </div>

            {isJTCNonJTCApproved? 
                <JTCLoanList data={leaseholdApprovedList} />
                :
                <MaxLoanList data={leaseholdApprovedList} />
            }

            {(maxLoanNoPropList.length > 0)&&
                <div className='pad-top20'>
                    <SingleFormLabelBold labelId={'lblAIPtxt2'} labelName={losData.leasehold.txt2} />
              
                    <MaxLoanList data={maxLoanNoPropList} />  
                </div>
            }

            <div className='pad-top10'>
                <SingleFormLabel labelId={'lblAIPtxt3'} labelName={losData.leasehold.txt3} />
            </div>
        </div>
    )
}

export default AAPLeaseholdProperty;